import apiClient, { prefetchApiCsrfToken } from "../common";

export type SendPurchaseOrderEmailResult = {
  recipient: string;
  cc: string[];
  subject: string;
  filename: string;
};

/** Cuerpo `{detail}` que el backend usa en 422 (proveedor sin correo) y 503. */
export type SendPurchaseOrderEmailErrorBody = {
  detail?: string;
};

/**
 * POST /api/v1/supply-documents/{id}/send-email/
 * Genera el PDF de la OC y lo envía al correo del proveedor dominante
 * (ProductAttribute "Email Contacto Proveedor"). 422 si el proveedor no tiene
 * correo cargado; el caller debe leer `error.response.data.detail` en ese caso.
 */
export async function apiSendPurchaseOrderEmail(
  supplyDocumentId: string,
): Promise<SendPurchaseOrderEmailResult> {
  await prefetchApiCsrfToken();
  const res = await apiClient.post(
    `supply-documents/${supplyDocumentId}/send-email/`,
    {},
    {
      withCredentials: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    },
  );
  const data = res.data as Partial<SendPurchaseOrderEmailResult>;
  return {
    recipient: String(data.recipient ?? ""),
    cc: Array.isArray(data.cc) ? data.cc.map(String) : [],
    subject: String(data.subject ?? ""),
    filename: String(data.filename ?? ""),
  };
}
